import { apiClient } from '@/lib/api/client'
import type {
  UpdateProfileDto,
  ChangePasswordDto,
  UserProfileResponseDto,
  UserSettingResponseDto,
} from '@fp3/shared'

export const profileApi = {
  getProfile: async (): Promise<UserProfileResponseDto> => {
    const { data } = await apiClient.get<UserProfileResponseDto>('/users/me')
    return data
  },

  updateProfile: async (dto: UpdateProfileDto): Promise<UserProfileResponseDto> => {
    const { data } = await apiClient.patch<UserProfileResponseDto>('/users/me', dto)
    return data
  },

  changePassword: async (dto: ChangePasswordDto): Promise<void> => {
    await apiClient.patch('/users/me/password', dto)
  },

  getSettings: async (): Promise<UserSettingResponseDto[]> => {
    const { data } = await apiClient.get<UserSettingResponseDto[]>('/users/me/settings')
    return data
  },

  upsertSetting: async (key: string, value: unknown): Promise<UserSettingResponseDto> => {
    const { data } = await apiClient.put<UserSettingResponseDto>(`/users/me/settings/${key}`, {
      value,
    })
    return data
  },

  deleteUser: async (): Promise<void> => {
    await apiClient.delete('/users/me')
  },
}
